import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Stack, Typography } from '@mui/material';
import { Modal } from '../../Modal';
import type { StartupStepProps } from '../StartupWizard.types';

export const StartBatteryStep = ({ onNext, onTurnOnBatteries, isMobile = false }: StartupStepProps) => {
  const { t } = useTranslation('startupWizard');
  const [isSending, setIsSending] = useState(false);

  const turnOnBatteries = async () => {
    setIsSending(true);
    try {
      await onTurnOnBatteries?.();
      onNext();
    } catch {
      // The consumer reports the failure (notification); stay open so the user can retry.
      setIsSending(false);
    }
  };

  const skip = () => {
    if (!isSending) {
      onNext();
    }
  };

  return (
    <Modal
      isOpen
      title={t('startBattery.title')}
      maxWidth="md"
      isMobile={isMobile}
      onClose={isSending ? undefined : onNext}
      onCancel={skip}
      cancelButtonTitle={t('startBattery.skip')}
      cancelButtonAlign="left"
      primaryButtonTitle={t('continue')}
      onPrimaryButtonClick={turnOnBatteries}
      primaryButtonProps={{ disabled: isSending }}
      data-testid="start-battery-modal"
    >
      <Stack spacing={3} pt={1}>
        <Typography>{t('startBattery.description')}</Typography>
        <Alert severity="warning">{t('startBattery.warning')}</Alert>
      </Stack>
    </Modal>
  );
};
